import React, { useState, useContext, useMemo, useEffect } from 'react';
import {
  Popover,
  Overlay,
  OverlayTrigger,
  Modal,
  Button,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTimes,
  faPencilAlt,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';
import { Trash } from 'react-bootstrap-icons';
import AppContext from '../../../../context';
import { removeCompany, getPortfolioMeta } from '../../../../../api';
import ClearPortfolio from '../clear_portfolio/clear_portfolio.component';
import ReturnsToggler from '../returns_toggler/returns_toggler.component';
import ViewTxs from '../view_txs/view_txs.component';
import DeleteTx from '../delete_tx/delete_tx.component';
import './all_pos.component.css';
import AllPosTable from './all_pos_table.component';
import AllPosTableMob from './all_pos_table_mob.component';
import HistoricDataUnavailable from '../../common/historic_data_unavailable/historic_data_unavailable.component';

const AllPos = (props) => {
  const context = useContext(AppContext);
  //map state to props
  const { state, setState, setContext } = props;
  const { portfolioId, returnsType, isMob } = state;
  const { data, error, isLoaderVisible } = state[portfolioId];
  const { show, currentCompany } = state.all_positions.viewTx;
  const { isModalVisible } = state.all_positions.deleteTx;
  const { threedotsContainer, showPopover } = state.all_positions;

  const updatePfMeta = async () => {
    try {
      let pfs = _.cloneDeep(context.portfolios);
      const pfMeta = await getPortfolioMeta(portfolioId);
      const pfIdx = context.portfolios.findIndex(
        (_pf) => _pf.id == portfolioId,
      );
      pfs[pfIdx] = pfMeta.data;
      setContext({
        portfolios: pfs,
        resetPf: { resetId: portfolioId, switchId: portfolioId },
      });
    } catch (error) {
      window.location.reload();
    }
  };

  const onRemoveCompany = async () => {
    try {
      const response = await removeCompany(portfolioId, currentCompany.fincode);
      setState('currentCompany', null);
      setState('isModalVisible', false);
      updatePfMeta();
    } catch (e) {}
  };

  const onEditTxs = () => {
    setState('show', false);
    setState('currentCompany', null);
    updatePfMeta();
  };

  const popover = (
    <Popover id="company-popover">
      <Popover.Content className="view" onClick={() => setState('show', true)}>
        <FontAwesomeIcon icon={faPencilAlt} />
        View/Edit
      </Popover.Content>
      {currentCompany && currentCompany.instrumentType != 'mutual_funds' && (
        <Popover.Content
          className="delete"
          onClick={() => setState('isModalVisible', true)}
        >
          <Trash className="trash" />
          Delete
        </Popover.Content>
      )}
    </Popover>
  );

  const infoPopover = (
    <Popover id="all-pos-info">
      <Popover.Content>
        This is a ledger of all current & historic investments in your portfolio
      </Popover.Content>
    </Popover>
  );

  const onThreedotsClick = (e, c) => {
    //setCurrentCompany(c);
    setState('threedotsContainer', e.target);
    setState('currentCompany', { ...c });
  };

  useEffect(() => {
    if (!currentCompany) return;
    if (!context.is_sample) {
      // setShowPopover(!showPopover);
      // setThreedotsContainer(e.target);
      setState('showPopover', !showPopover);
      // setState('threedotsContainer', e.target);
    } else {
      setState('show', true);
    }
  }, [currentCompany]);

  useEffect(() => {
    if (show || isModalVisible) {
      //setShowPopover(false);
      setState('showPopover', false);
    }
  }, [show, isModalVisible]);

  useEffect(() => {
    //responsive
    let timeoutId = null;
    const onResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        if (window.innerWidth < 440) {
          setState('isMob', true);
        } else {
          setState('isMob', false);
        }
      }, 50);
    };
    onResize();
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return (
    <div className={props.show ? '' : 'd-none'}>
      {context.portfoliosById[portfolioId].broker ? (
        <HistoricDataUnavailable />
      ) : (
        <>
          <div
            className={`scrollable position-relative pos-cont ${
              isMob ? 'mob' : ''
            }`}
          >
            {!context.is_sample && (
              <Overlay
                show={showPopover}
                target={threedotsContainer}
                placement="bottom"
                rootClose={true}
                onHide={() => setState('showPopover', false)}
              >
                {popover}
              </Overlay>
            )}
            {!isMob ? (
              <AllPosTable
                summary={data}
                returnsType={returnsType}
                onThreedotsClick={onThreedotsClick}
                isBroker={!!context.portfoliosById[portfolioId].broker}
                showViewEditTx={
                  !context.portfoliosById[portfolioId].broker ||
                  context.portfoliosById[portfolioId].has_mfs
                }
              />
            ) : (
              <AllPosTableMob
                summary={data}
                returnsType={returnsType}
                onThreedotsClick={onThreedotsClick}
                isBroker={!!context.portfoliosById[portfolioId].broker}
                showViewEditTx={
                  !context.portfoliosById[portfolioId].broker ||
                  context.portfoliosById[portfolioId].has_mfs
                }
              />
            )}
            {show && (
              <ViewTxs
                show={show}
                handleClose={() => {
                  setState('show', false);
                }}
                onEditTxs={onEditTxs}
                fincode={currentCompany.fincode}
                instrumentType={currentCompany.instrumentType}
                fetchSummary={props.fetchSummary}
                portfolioId={portfolioId}
                setContext={setContext}
              />
            )}
          </div>
          <p className="content-info-text mt-2 mb-1">
            * This is a ledger of all current & historic investments in your
            portfolio
          </p>
        </>
      )}
      <DeleteTx
        show={isModalVisible}
        setShow={(v) => setState('isModalVisible', v)}
        company={currentCompany}
        onRemoveCompany={onRemoveCompany}
      />
    </div>
  );
};

export default AllPos;
